// Import react elements.
import { useState } from "react";

// Import css stylesheet.
import "./FaqGrid.css";



// Export the reusable FAQ grid.
export const FaqGrid = ({
    sections = [],
    headingTag = "h2",
}) => {

    // Track which FAQ sections have been expanded.
    const [expandedSections, setExpandedSections] = useState({});

    // Set the heading element used for each section.
    const SectionHeading = headingTag;



    // Expand or collapse a FAQ section.
    const toggleSection = (sectionKey) => {

        setExpandedSections((currentSections) => ({
            ...currentSections,
            [sectionKey]: !currentSections[sectionKey],
        }));

    };



    // Return nothing when no FAQ sections have been supplied.
    if (!Array.isArray(sections) || sections.length === 0) { return null; }



    // Render the FAQ sections.
    return (

        <div className="faq-grid">

            {/* Loop through each FAQ section. */}
            {sections.map((section, sectionIndex) => {

                // Prepare the section display state.
                const sectionKey = section?.id ?? sectionIndex;
                const sectionFaqs = Array.isArray(section?.faqs) ? section.faqs : [];
                const sectionExpanded = expandedSections[sectionKey] === true;
                const visibleFaqs = sectionExpanded ? sectionFaqs : sectionFaqs.slice(0, 3);
                const hiddenFaqCount = Math.max(sectionFaqs.length - 3, 0);

                // Render the section and its FAQs.
                return (

                    <section
                        className="faq-grid__section"
                        key={sectionKey}
                    >

                        {/* Render the section heading. */}
                        <div className="faq-grid__section-heading">

                            <SectionHeading className="faq-grid__section-title">
                                {section?.name}
                            </SectionHeading>

                            <p className="faq-grid__section-description">
                                {section?.description || ""}
                            </p>

                        </div>

                        {/* Render the visible FAQs in this section. */}
                        <div className="faq-grid__items">

                            {/* Loop through each visible FAQ. */}
                            {visibleFaqs.map((faq, faqIndex) => (

                                // Render an expandable FAQ.
                                <details
                                    className="faq-grid__faq"
                                    key={faq?.id ?? faqIndex}
                                >

                                    {/* Render the FAQ question. */}
                                    <summary className="faq-grid__question">
                                        {faq?.question}
                                    </summary>

                                    {/* Render the trusted FAQ answer HTML. */}
                                    <div
                                        className="faq-grid__answer"
                                        dangerouslySetInnerHTML={{ __html: faq?.answer || "" }}
                                    />

                                </details>

                            ))}

                        </div>

                        {/* Allow sections with more than three FAQs to be expanded. */}
                        {hiddenFaqCount > 0 && (
                            <button
                                className="faq-grid__more"
                                type="button"
                                onClick={() => toggleSection(sectionKey)}
                                aria-expanded={sectionExpanded}
                            >
                                {sectionExpanded ? "Show less" : `Show ${hiddenFaqCount} more`}
                            </button>
                        )}

                    </section>

                );

            })}

        </div>

    );

};